
<div >
  <div :class="['mask', openDrawer ? 'open' : 'close']" @click="close"></div>
  <div :class="['drawer', placement, openDrawer ? 'open' : 'close']">
    <div ref="drawer" style="position: relative; height: 100%;">
      <slot></slot>
    </div>
    <div v-if="showHandler" :class="['handler-container', placement]" ref="handler">
    </div>
  </div>
</div>
